import "core-js/modules/es.array.push.js";
import { ref } from 'vue';
import { get, post } from '../../api/utils/request.ts';
import MyNavBarVue from '../../components/MyNavBar.vue';
import { closeToast, showLoadingToast, showSuccessToast, showFailToast } from 'vant';
export default {
  components: {
    MyNavBarVue
    //  detail 
  },

  setup() {
    const NotFind = ref(false);
    const active = ref();
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const objIsEmpty = obj => {
      if (typeof obj === 'undefined' || obj == null || obj === '') {
        return true;
      } else {
        return false;
      }
    };
    return {
      NotFind,
      refreshing,
      active,
      objIsEmpty,
      list,
      cno: '',
      loading,
      finished,
      page: 1,
      rows: 10
    };
  },
  data() {
    return {};
  },
  created() {
    //在组件实例处理完所有与状态相关的选项后调用。
    const tabActive = localStorage.getItem('tabActive');
    if (tabActive) {
      this.active = ref(parseInt(tabActive));
    } else {
      this.active = ref(0);
    }
  },
  mounted() {
    //在组件被挂载之后调用
    this.cno = this.$route.query.CustomerCode;

    // if(this.objIsEmpty(this.cno)){
    //   showToast({
    //     message: '未獲取到客戶代碼',
    //     position: 'bottom',
    //   });
    //   return
    // }
    // this.query(this.active==0?2:1,this.cno)
  },

  methods: {
    ToUrl(item) {
      this.$router.push({
        path: '/ServiceRecordDetail',
        query: {
          id: item.id,
          type: item.serviceType
        }
      });
    },
    onLoad(type) {
      this.query(this.active == 0 ? 2 : this.active == 2 ? 3 : 1, this.cno, type);
    },
    onRefresh() {
      this.reload();
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad(1);
    },
    reload() {
      // this.list=[];
      this.loading = true;
      this.page = 1;
      this.finished = false;
    },
    onClickTab({
      title
    }) {
      localStorage.setItem('tabActive', this.active);
      this.reload();
      showLoadingToast({
        message: '加載中...',
        forbidClick: true
      });
      this.query(this.active == 0 ? 2 : this.active == 2 ? 3 : 1, this.cno, 1);
    },
    query(state, cno, type) {
      //获取服务记录
      get('/api/services/app/ServiceRecord/GetListByState', {
        state: state,
        CNo: cno,
        page: this.page,
        rows: this.rows
      }).then(res => {
        closeToast();
        this.loading = false;
        this.refreshing = false;
        if (res.success) {
          if (res.result.data.length > 0) {
            this.NotFind = false;
            console.info(res.result);
            if (type == 1) {
              this.list = res.result.data;
            } else {
              this.list = this.list.concat(res.result.data);
            }
            if (res.result.total <= this.page) {
              this.finished = true;
            } else {
              this.page = this.page + 1;
            }
          } else {
            this.NotFind = true;
            this.finished = true;
          }
        } else {
          this.NotFind = true;
          this.finished = true;
        }
      });
    }
  }
};